import { IDotTuyenSinh } from "../../../model/respone/category/IDotTuyenSinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotTuyenSinhActionsObj = {
  LOAD_START: 0,
  LOAD_SUCCESS: {} as IDotTuyenSinh[],
  LOAD_ERRR: "",
};
export const eDotTuyenSinhActionIds = generateActionTypeIds(
  eDotTuyenSinhActionsObj,
  "DOT_TUYEN_SINH"
);
export type IDotTuyenSinhActionTypes = IGenericActionType<
  typeof eDotTuyenSinhActionsObj,
  "DOT_TUYEN_SINH"
>;
